var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCopy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 7.867,
  height: 7.867,
  x: 2.9,
  y: 0.4,
  fill: "#fff",
  stroke: "#555",
  strokeWidth: 0.8,
  rx: 1.333
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 8.367,
  height: 8.367,
  x: 0.4,
  y: 2.4,
  fill: "#fff",
  stroke: "#555",
  strokeWidth: 0.8,
  rx: 1.433
})));
export default SvgIconCopy;